export const environment = {
  production: false,
  serverUrl: 'https://ab-server-vjeitewcwq-de.a.run.app',
  storageUrl: 'https://storage.googleapis.com/acarabook-staging-public/',
  // serverUrl: 'http://localhost:8000',
};
